import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useAudioRecorder } from '@hooks/useAudioRecorder';
import { Box, Button, CircularProgress, Typography, useMediaQuery, useTheme, } from '@mui/material';
import { RecordingWaveform } from './RecordingWaveform';
import { RecordingStatus } from './types';
export const AudioRecorder = ({ startRecorderLabel, stopRecorderLabel, onRecordingComplete, onError, maxRecordingDuration, }) => {
    const { status, startRecording, stopRecording, resetRecording } = useAudioRecorder(onRecordingComplete, onError, maxRecordingDuration);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    const isRecording = status === RecordingStatus.RECORDING;
    const isRequesting = status === RecordingStatus.REQUESTING_PERMISSION;
    const handleStartRecording = () => {
        startRecording();
    };
    const handleReset = () => {
        // resetRecording handles everything:
        // - Stops recording if active
        // - Cleans up blob URL
        // - Resets state to IDLE
        resetRecording();
    };
    return (_jsxs(Box, { sx: {
            display: 'flex',
            flexDirection: { xs: 'column', md: 'row' },
            justifyContent: { xs: 'flex-start', md: 'space-between' },
            alignItems: { xs: 'stretch', md: 'center' },
            py: { xs: 3, md: 4 },
            gap: { xs: 3, md: 2 },
        }, children: [isRecording && (_jsxs(Box, { display: "flex", gap: 2, alignItems: "center", justifyContent: { xs: 'center', md: 'flex-start' }, children: [_jsx(RecordingWaveform, {}), _jsx(Typography, { variant: "body1", color: "text.secondary", fontStyle: "italic", fontSize: { xs: 14, md: 16 }, fontWeight: 600, children: "Recording..." })] })), _jsx(Box, { sx: {
                    display: 'flex',
                    gap: 2,
                    justifyContent: { xs: 'center', sm: 'flex-end' },
                    flexWrap: 'wrap',
                    width: '100%',
                }, children: isRecording ? (_jsxs(_Fragment, { children: [_jsx(Button, { variant: "contained", color: "error", onClick: stopRecording, fullWidth: isMobile, sx: { minWidth: 120 }, children: stopRecorderLabel ?? 'Stop' }), _jsx(Button, { variant: "outlined", color: "error", onClick: handleReset, fullWidth: isMobile, sx: { minWidth: 120 }, children: "Reset" })] })) : (_jsx(Button, { variant: "contained", onClick: handleStartRecording, disabled: isRequesting, fullWidth: isMobile, startIcon: isRequesting ? (_jsx(CircularProgress, { size: 20, color: "inherit" })) : null, sx: { minWidth: 120 }, children: isRequesting
                        ? 'Requesting Permission...'
                        : (startRecorderLabel ?? 'Start') })) })] }));
};
